import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <div className="title">
        <p>About Me</p>
      </div>
      <p>
        I am a second-year Electrical Engineering student at the University of Toronto        
      </p>
      <p>
        I am interested in careers related to power systems, control systems, and software development
      </p>
      <p>
        Next year, I will pursue a minor in Sustainable Energy to strengthen my understanding of energy systems and their role in building cleaner, more efficient communities.
      </p>
      <p>
        I am seeking a Summer 2026 co-op opportunity to gain hands-on experience, work on practical projects, and explore potential career paths after graduation
      </p>
    </div>
  );
};

export default About;